import React, { useEffect, useState } from 'react';
import BolPara from '../../src/assets/bolParaBg.png';
import CoinHand from '../../src/assets/coins-hand.png';
import Button from '../components/Button';
import HorizontalScroll from '../components/HorizontalScroll';
import PartnerCircle from '../components/PartnerCircle';
import { useNavigate, useParams } from 'react-router-dom';
import Services from '../services/Services';
import { CircularProgress } from '@mui/material';
import { getOrCreateSessionID } from '../utils/sessionManager';
import { logEvent } from '../utils/analyticsManager'; // GA4 Import

export default function MainPage() {
    const navigate = useNavigate();
    const { token } = useParams();

    const [companies, setCompanies] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [sessionID, setSessionID] = useState(null);

    const handleRedirectToApplications = () => {
        navigate(`/${token}/applications`);
    };

    const getCompanies = () => {
        Services.GetBolParaCompanies(token)
            .then((res) => {
                if (res.data.status) {
                    setCompanies(res.data.result)
                }
                else {
                    setCompanies([])
                }
                setIsLoading(false)
            })
            .catch((err) => console.log(err));
    }

    // SessionID oluştur ve sayfa yüklenme event'i gönder
    useEffect(() => {
        const sid = getOrCreateSessionID();
        setSessionID(sid);

        // GA4: Sayfa yüklenme (Page View zaten oto gider ama custom event istersen):
        logEvent('Anasayfa', 'Bol Para Sayfası Açıldı', 'MainPage View');

        // Mevcut Backend Tracking
        Services.AddAnalyticsTracking(
            token,
            sid,
            'page_load',
            'MainPage',
            'view'
        ).catch((err) => console.log('Analytics tracking error:', err));

        getCompanies();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const itemList = companies.map((company) => (
        <PartnerCircle
            key={company.id}
            image={company.logo}
            name={company.title}
            token={token}
            companyID={company.companyID}
            company={company}
            sessionID={sessionID}
        />
    ));

    return (
        <body>
            <div className='main'>
                {isLoading ?
                    <div style={{ marginTop: '35%' }}>
                        <CircularProgress />
                    </div >
                    :
                    <>
                        <img src={BolPara} alt="Bol Para" className='bolpara-image' />

                        <div style={{ alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'row', display: 'flex', alignSelf: 'flex-start' }}>
                            <img src={CoinHand} alt="-" style={{ marginRight: '3px' }} />
                            <p style={{ color: '#EE7F2B', fontWeight: '700', fontSize: '18px' }}>Bol Para <text style={{ color: '#494D59' }}>Nedir?</text></p>
                        </div>
                        <div style={{ alignSelf: 'flex-start' }}>
                            <text style={{ color: '#64748B', fontWeight: '400', fontSize: '12px' }}>
                                Easy Point’in anlaşmalı olduğu markaların ürünlerini satarak ek gelir elde etmenizi sağlayan harika bir fırsattır. Günlük işlerinizi yaparken, bu ürünleri satışa sunarak ekstra para kazanabilirsiniz!
                            </text>
                        </div>

                        <p style={{ color: '#494D59', fontWeight: '700', fontSize: '16px', alignSelf: 'flex-start' }}>Partner Markalarımız</p>

                        <HorizontalScroll itemList={itemList}/>

                        <Button onClick={() => handleRedirectToApplications()} label={'Başvuruları Görüntüle'} />
                    </>
                }

            </div>

        </body>
    )
}